// extracted by mini-css-extract-plugin
export var globalCart = "RightMenu_globalCart__dX1jI";
export var loginPageRightMenuContainer = "RightMenu_loginPageRightMenuContainer__Pu8ZB";
export var rightMenuContainer = "RightMenu_rightMenuContainer__TD2iW";